<template>
  <div>
    <div
      class="text-xl text-gray-100 cursor-pointer"
      @click="toggleDarkMode()"
    >
      <i
        v-if="theme === 'light'"
        class="fas fa-moon"
      />
      <i
        v-else
        class="fas fa-sun"
      />
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue"
import eventBus from "@/utils/event-bus";


export default defineComponent({
  name: 'DarkModeToggle',

  data() {
    return {
      theme: document.documentElement.classList.contains('dark') ? 'dark' : 'light'
    }
  },

  methods: {
    toggleDarkMode() {
      const node = document.querySelector('html');
      if (node.classList.contains('dark')) {
        node.classList.remove('dark');
        localStorage.theme = 'light'
      } else {
        node.classList.add('dark');
        localStorage.theme = 'dark'
      }

      this.theme = localStorage.theme;
      eventBus.$emit('themeChanged', this.theme);
    }
  }
});
</script>

<style>

</style>